import {createHashRouter, Navigate, useOutletContext} from 'react-router-dom';
import RegistrationContainer from '@containers/Registration/index';
import AccountSetUp from '@components/registration/AccountSetUp';
import NewExistingDecision from '@components/registration/NewExistingDecision';
import OfficeDetails from '@components/registration/OfficeDetails';
import VerifyAccount from '@components/registration/VerifyAccount';
import NotValidated from '@components/registration/NotValidated';
import MultipleAddresses from '@components/registration/MultipleAddresses';
import AccountVerifiedNPI from '@components/registration/AccountVerifiedNPI';
import AccountRequiresVerification from '@components/registration/AccountRequiresVerification';
import RegistrationLocked from '@components/registration/RegistrationLocked';
import RegistrationErrorPage from '@containers/Registration/ErrorPage';

const AccountSetupRoot = () => {
    const context = useOutletContext();
    if ( context.isRegistrationLocked() ) {
        return <RegistrationLocked/>;
    }

    return <AccountSetUp/>;
};

const routes = createHashRouter( [
    {
        path: '/*',
        element: <RegistrationContainer/>,
        errorElement: <RegistrationErrorPage/>,
        children: [
            {
                path: '*',
                element: <AccountSetupRoot/>
            },
            {
                path: 'newExistingDecision',
                element: <NewExistingDecision/>
            },
            {
                path: 'officeDetails',
                element: <OfficeDetails/>
            },
            {
                path: 'verifyAccount',
                element: <VerifyAccount/>
            },
            {
                path: 'notValidated',
                element: <NotValidated/>
            },
            {
                path: 'multipleAddresses',
                element: <MultipleAddresses/>
            },
            {
                path: 'accountVerifiedNPI',
                element: <AccountVerifiedNPI/>
            },
            {
                path: 'accountRequiresVerification',
                element: <AccountRequiresVerification/>
            },
            {
                path: 'registrationLocked',
                element: <RegistrationLocked/>
            },
            {
                path: '*',
                element: <Navigate to="/registration"/>
            }
        ]
    }

] );

export default routes;
